module.exports = __webpack_public_path__ + "img/cool.be5030ca.webp";